import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    width: '100%',
  },
  tooltip: {
    fontSize: '10px',
    lineHeight: 'auto',
    height: '56px',
  },
  boxTitle: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  pageDesc: {
    padding: 10,
  },
  tableCheck: {
    padding: '0 !important',
  },
  paper: {
    backgroundColor: '#ffffff',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    boxShadow: theme.shadows[0],
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  paperModel: {
    paddingTop: theme.spacing(1),
    padding: theme.spacing(3),
    width: '90%',
    maxWidth: '900px',
    height: 'auto',
    maxHeight: '90vh',
    overflowY: 'auto',
    borderRadius: '8px',
  },
  modalContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },

  text: {
    textAlign: 'center',
    margin: 'auto',
    color: 'grey',
  },
  textBox: {
    marginBottom: theme.spacing(3),
    fontSize: 14,
    color: 'rgb(0 0 0 / 54%)',
  },

  rowWide: {
    position: 'relative',
    marginBottom: theme.spacing(3),
  },
  row: {
    position: 'relative',
    alignItems: 'center',
  },
  title: {
    display: 'flex',
    width: '20%',
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  desc: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    marginLeft: theme.spacing(1),
    padding: theme.spacing(1.7),
    fontSize: 12,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  input: {
    width: '100%',
    color: 'rgb(0 0 0 / 87%)',
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  btn: {
    padding: theme.spacing(1, 2),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWide: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
  },
  imgBox: {
    width: 136,
    padding: 0,
  },
  fieldsBox: {
    width: 'calc(100% - 140px)',
    paddingLeft: theme.spacing(4),
    paddingRight: 0,
  },
  link: {
    color: '#5081FF',
  },
  notify: {
    '& .MuiTypography-body1 ': {
      fontSize: '14px',
    },
  },
  halfSizeRow: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  inputOne: {
    width: 'calc(100% - 170px)',
    color: 'rgb(0 0 0 / 87%)',
  },
  btnWideLeft: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    marginRight: 10,
  },
  tableBox: {
    width: '100%',
    padding: 0,
  },
  userImg: {
    width: 136,
    height: 136,
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #5081FF',
    borderRadius: 8,
    marginBottom: theme.spacing(2),
    overflow: 'hidden',
  },
  actionBox: {
    position: 'absolute',
    right: 0,
  },

  submitBtn: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    whiteSpace: 'nowrap',
    backgroundColor: '#E2222B',
    fontWeight: 500,
    lineHeight: '26px',

    letterSpacing: '0.46px',
    textTransform: 'capitalize',

    color: '#FFFFFF',
  },
  submitBtns: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    whiteSpace: 'nowrap',
    backgroundColor: '#5081ff',
    fontWeight: 500,
    lineHeight: '26px',
    letterSpacing: '0.46px',
    textTransform: 'capitalize',
    color: '#FFFFFF',
  },
  topText: {
    color: 'rgb(0 0 0 / 54%)',
    paddingBottom: '16px',
    fontWeight: 500,
    fontSize: 14,
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  btnContainers: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  heading: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '133.4%',
    color: '#000000',
    margin: '24px 0',
    background: '#F6F6F6',
    padding: '0 16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftCol: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '24px',
  },
  rightCol: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: '24px',
  },
  profilePicture: {
    borderRadius: '50%',
    width: 100,
    height: 100,
  },
  profileContainer: {
    minWidth: '100px',
    borderRadius: '50%',
    marginRight: '24px',
  },
  uploadBtnContainer: {
    minWidth: '216px',
    gap: '12px',
    borderRadius: '4px',
    marginRight: '24px',
  },
  removeBtnContainer: {
    width: '107px',
    gap: '12px',
    borderRadius: '4px',
    marginRight: '24px',
  },
  btnLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: 'black',

    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  link2: {
    background: '#5081FF',
    color: 'white',
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  border: {
    border: '1px solid #E0E0E0',
  },
  boxes: {
    width: '80% !important',
  },
  border1: {
    width: '50%',
    border: '1px solid #E0E0E0',
  },
  titlecontent: {
    margin: '10px 0 10px 0',
    fontWeight: 600,
    fontSize: 16,
  },
  width50: {
    width: '50%',
  },
  mainHeading: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    color: '#000000',
  },
  companyHeadTitle: {
    '& .MuiFormControl-root': {
      width: '100%',
    },
  },
  subHeading: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '15px',
    color: 'rgba(0, 0, 0, 0.87)',
  },

  cellTitle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  titleLink: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    color: '#5081FF',
    cursor: 'pointer',
  },
  cellLink: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: '#5081FF',
    cursor: 'pointer',
    '& .MuiInputBase-input': {
      color: '#5081FF',
    },
  },
  linktitle: { color: '#5081FF' },
  cellLinkhead: {
    '& .MuiInputBase-input': {
      textAlign: 'right',
    },
  },
  cellInputLink: {
    '& .MuiInputBase-input': {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      color: '#5081FF',
    },
  },
  companytitle: {
    '& .MuiInputBase-input': {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: 27,
    },
  },
}));
